module.exports = __webpack_public_path__ + "663a364a3.png";